import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { augInctvFieldDefs } from '@/sc/inctvFieldDefs';

export const InctvClaimList = () => {
  return <EntityList augFieldDefs={augInctvFieldDefs} />;
};
